import type { AnnotationLabelT } from '../../../common/types/types';
import type { AnnotationT } from '../../labelling/types';
import type { AnnotationFrameWriteEntry } from '../atoms/studio-store-write/actions';
import type { StudioStore } from '../studio-store';
import type { MetadataPayload } from '../studio-store/types';
import { buildAnnotationForOutput } from './build-annotation-for-output';
export async function snapshotAnnotationFrames(studioStore: StudioStore, metadata: MetadataPayload, annotationLabels: AnnotationLabelT[], annotationId: string, startIndex: number, endIndexInclusive: number): Promise<Record<number, AnnotationT>> {
  const frameCount = Math.max(0, endIndexInclusive - startIndex + 1);
  const framePayloads = await Promise.all(Array.from({
    length: frameCount
  }, (_, i) => studioStore.getAnnotationFrameAtIndex(startIndex + i, annotationId)));
  const snapshot: Record<number, AnnotationT> = {};
  for (const [i, framePayload] of framePayloads.entries()) {
    const frameIndex = startIndex + i;
    snapshot[frameIndex] = buildAnnotationForOutput(framePayload, metadata, annotationLabels, frameIndex);
  }
  return snapshot;
}
export function toFrameWriteEntries(annotationId: string, snapshot: Record<number, AnnotationT>): AnnotationFrameWriteEntry[] {
  return Object.entries(snapshot).map(([frameIndex, annotation]) => ({
    frameIndex: Number(frameIndex),
    annotationId,
    annotation
  }));
}